import { Link } from "react-router-dom";
import NotaIcon from "formassets/nota.svg?react";
import TagIcon from "formassets/tag-icon.svg?react";
import UpdatedIcon from "formassets/updated-icon.svg?react";
import styles from "./styles.module.scss";

interface Props {
  tag?: string;
  title: string;
  subtitle?: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

export function Section({ title, children }: SectionProps) {
  return (
    <section className={styles.section}>
      <div className={styles.card}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        <div className={styles.cardBody}>{children}</div>
      </div>
    </section>
  );
}

function LegalPage({ tag, title, subtitle, lastUpdated, children }: Props) {
  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.brand}>
            <NotaIcon className={styles.brandLogo} />
          </Link>
          <nav className={styles.nav}>
            <Link to="/" className={styles.navLink}>
              Strona główna
            </Link>
            <Link to="/regulamin" className={styles.navLink}>
              Regulamin
            </Link>
            <Link to="/polityka-prywatnosci" className={styles.navLink}>
              Polityka prywatności
            </Link>
          </nav>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.hero}>
          {tag && (
            <span className={styles.tag}>
              <TagIcon className={styles.tagIcon} />
              {tag}
            </span>
          )}
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          {lastUpdated && (
            <p className={styles.updated}>
              <UpdatedIcon className={styles.updatedIcon} />
              Ostatnia aktualizacja: {lastUpdated}
            </p>
          )}
        </div>

        <article className={styles.article}>{children}</article>

        <Section title="Kontakt">
          <p>
            Jeśli masz jakiekolwiek pytania lub wątpliwości, skontaktuj się z
            nami pod adresem{" "}
            <a href="mailto:kontakt@notaup.pl">kontakt@notaup.pl</a>
          </p>
        </Section>
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <span>Copyright © 2026 KFJ Inwestycje Sp. z o. o.</span>
          <nav className={styles.footerNav}>
            <Link to="/regulamin">Regulamin</Link>
            <Link to="/polityka-prywatnosci">
              Polityka prywatności i cookie
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default LegalPage;
